
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  ALLOW_ANALYTICS: true,
  AUTH_BASE_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/auth',
  DOCUMENT_BASE_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/document',
  LEGACY_HUB_LOGIN: 'https://portal.pre.prod01.platform.legacy.intelycare.com/hub/views/login.html',
  POOL_BUCKET: 'poolscheduling.pre.prod01.platform.legacy.intelycare.com',
  SCHEDULING_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/poolscheduling',
  SHIFT_BASE_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/backend',
  SHIFT_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/shift',
  SOCKET_BASE_URL: 'https://socket.pre.prod01.platform.legacy.intelycare.com',
  ALLOW_MARKETO: true,
  AUTH_SERVICE_BASE_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/authservice',
  CLIENTID: '1',
  INTERNAL_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com',
  ISYSTEM_BASE_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/isystem',
  SERVICE: 'ISchedule',
  STAFF_BASE_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/poolstaff',
  TASK_BASE_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/staff/notes',
  USER_BASE_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/jwt/user',
  ISYSTEM_BYPASS_GATEWAY_BASE_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/isystem',
  SHIFT_JAVA_URL: 'https://api.pre.prod01.platform.legacy.intelycare.com/poolscheduling'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.